import { useTheme } from "../../glassTheme.tsx";
import { markRanges } from "../../searchHighlight.ts";

/** Text with the query's words marked. No matches: the text, untouched. */
export function Marked({ text, tokens }: { text: string; tokens: string[] }) {
  const { colors } = useTheme();
  const ranges = markRanges(text, tokens);
  if (ranges.length === 0) return <>{text}</>;
  const out: React.ReactNode[] = [];
  let at = 0;
  ranges.forEach(([a, b], i) => {
    if (a > at) out.push(text.slice(at, a));
    out.push(
      <mark key={i} style={{
        background: colors.accentSoft, color: "inherit", borderRadius: 3, padding: "0 1px", margin: "0 -1px",
        boxShadow: `inset 0 -1.5px 0 ${colors.accent}`,
      }}>{text.slice(a, b)}</mark>,
    );
    at = b;
  });
  if (at < text.length) out.push(text.slice(at));
  return <>{out}</>;
}
